// src/services/busService.js

const BASE_URL = `${process.env.REACT_APP_BASE_URL}/api/v2/bus`; 

export const getBusById = async (busId, token) => {
  try {
    const response = await fetch(`${BASE_URL}/id/${busId}`, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      signal: AbortSignal.timeout(15000), // si se cuelga, devolvemos null en vez de esperar para siempre
    });

    if (!response.ok) {
      throw new Error(`Error fetching bus details for ID: ${busId}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("❌ Error en getBusById:", error);
    return null;
  }
};